import React, {useState} from 'react';
import {DI} from 'modules';

export function LiveRestrictions(props) {
    const maxLeftLength = 400;
    const strings = props.common.strings;
    const fullText = props.text;

    let leftText = fullText;
    let spaceIndex = -1;

    if (!props.text) {
        return null;
    }

    if (props.text.length > maxLeftLength) {
        leftText = fullText.slice(0, maxLeftLength);
        spaceIndex = leftText.lastIndexOf(' ');
        leftText = fullText.slice(0, spaceIndex);
    }

    const [showFull, setShowFull] = useState(
        leftText === fullText || spaceIndex === -1
    );

    const restrictions = showFull ? fullText : leftText;
    return (
        <div className="live-subblock">
            <div className="live-restrictions">
                <span className="live-restrictions__label">
                    {strings['page.lives.view.restrictions.title']}
                </span>
                <span className="live-restrictions__value">
                    {restrictions.split(/\n/g).map((text, index) => (
                        <p key={index}>{text}</p>
                    ))}
                </span>
                {showFull ? null : (
                    <button
                        type="button"
                        className="btn-bord live-restrictions__full"
                        onClick={() => setShowFull(true)}
                    >
                        {strings['page.lives.view.restrictions.button']}
                    </button>
                )}
            </div>
        </div>
    );
}

export default DI()(LiveRestrictions);
